module.exports = __webpack_public_path__ + "static/media/02.04d01929.svg";